import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('IssueViewJournalController', IssueViewJournalController);

    function IssueViewJournalController(
        $stateParams,
        $state,
        CompanyFactory,
        CompaniesFactory,
        toastr
    ) {
        var vm = this;

        vm.commentVisibilityOptions = [
            { key: 'Komentarz wewnętrzny', value: 0 },
            { key: 'Komentarz widoczny dla klienta', value: 1 },
            { key: 'Komentarz widoczny dla klienta i mieszkańców', value: 2 },
        ];
        vm.commentVisibility = 1;

        vm.sendDataToBackend = function () {
            if (vm.commentVisibility === 0) {
                var dataToSend = { notes: vm.notesToBackend, private: true, visibility: 0 };
            } else if (vm.commentVisibility === 1) {
                var dataToSend = { notes: vm.notesToBackend, private: false, visibility: 0 };
            } else if (vm.commentVisibility === 2) {
                var dataToSend = { notes: vm.notesToBackend, private: false, visibility: 2 };
            }

            CompanyFactory.readCompany().then(function (comp_id) {
                CompaniesFactory.addToJournal(
                    comp_id.data.organization.party_uuid,
                    $stateParams.issue_id,
                    dataToSend
                ).success(function () {
                    toastr.success('Zapisano zmiany');
                    $state.reload('company_employee.issue_list.details');
                });
            });
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_view/journal/journal.controller.ts